import api from "../axios";

/*
|--------------------------------------------------------------------------
| GET PUBLIC OFFERING OVERVIEW
|--------------------------------------------------------------------------
|
| Backend:
| GET /api/offering-overview/:slug
|
| Axios baseURL:
| http://localhost:5000/api
|
| Final request:
| http://localhost:5000/api/offering-overview/:slug
|
| Public endpoint — no authentication required.
|--------------------------------------------------------------------------
*/

export const getOfferingOverview = async (slug) => {

  if (!slug) {
    throw new Error("Offering slug is required");
  }

  const response = await api.get(
    `/offering-overview/${encodeURIComponent(slug)}`
  );

  return response.data;
};